module.exports = __webpack_public_path__ + "static/396FC6_3_0-484f644a06c55f4776bd18e716719518.woff";